import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class ChangeEmail extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
ChangeEmail.modelName = 'ChangeEmail';
const servicePath = 'change-email'
const servicePlugin = makeServicePlugin({
  Model: ChangeEmail,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
